import React, {useCallback, useEffect, useState} from "react";
import {
    Page,
    Layout,
    Button,
    LegacyCard,
    Banner,
    ResourceListProps,
    List, Spinner, CalloutCard, Tabs, Link
} from "@shopify/polaris";
import Http from "../Lib/Http";
import {Redirect} from "@shopify/app-bridge/actions";
import {useGoTo} from "@admin/Lib/useGoTo";
import Menu from "@admin/Lib/Menu";


function Install() {
    const [baseURL, setBaseURL] = useState<string | null>(null);
    const [appBlockLiveLink, setAppBlockLiveLink] = useState<string | null>(null);
    const [canAutoInstall, setCanAutoInstall] = useState<boolean>(false);
    const [hasAppBlocks, setHasAppBlocks] = useState<boolean>(true);
    const [loading, setLoading] = useState(false);
    const [displayInfo, setDisplayInfo] = useState(true);
    const goTo = useGoTo();
     const [selected, setSelected] = useState(0);
    const [selectedItems, setSelectedItems] = useState<
        ResourceListProps['selectedItems']
    >([]);


    useEffect(() => {
        getShops()

        const isBannerDismissed = localStorage.getItem('info_banner_dismissed') === 'true';
        setDisplayInfo(!isBannerDismissed);
    }, []);

    useEffect(() => {

        if(displayInfo){
            localStorage.setItem('info_banner_dismissed', 'false');
        }else{
            localStorage.setItem('info_banner_dismissed', 'true');
        }

     }, [displayInfo]);


    const getShops = () => {
        setLoading(true) ;

        Http.get(`/app/api/v1/shop.json?help=1`)
            .then((response) => {
                let shop = response.data.shop
                if(response.data.hasAppBlock == 1) {
                   setHasAppBlocks(true);
                }else{
                    setHasAppBlocks(false);
                }


                if(shop.shop_domain){
                    setBaseURL(shop.shop_domain.split('.')[0]);
                }

               setAppBlockLiveLink(response.data.appBlockLiveLink) ;
               setLoading(false) ;
                Menu.loadMenu(shop);

            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false) ;
            });
    };

    const openSupport = () => {
        window.open('mailto:support@eastsideco.com', '_blank');
    };


    const goToEditor = () => {
        if(appBlockLiveLink){
            let redirect = Redirect.create(window.app);
            redirect.dispatch(Redirect.Action.REMOTE, {
                url: appBlockLiveLink,
                newContext: true,
            });
        }
    };

    const handleTabChange = useCallback(
        (selectedTabIndex: number) => setSelected(selectedTabIndex),
        [],
    );


    const tabs = [
        {
            id: 'Inline',
            content: 'Inline',
            accessibilityLabel: 'Inline',
            panelID: 'Inline',
        },
        {
            id: 'Popup Link',
            content: 'Popup Link',
            panelID: 'Popup-Link',
        },
        {
            id: 'Popup Button',
            content: 'Popup Button',
            panelID: 'Popup-Button',
        }
    ];



    return (
        <Page backAction={{
            content: 'Home', onAction() {
                goTo('')
            }
        }}
              title="Installation Instructions">
            <Layout>
                {hasAppBlocks &&
                    <Layout.Section>
                        <CalloutCard
                            title="Installation as an app block"
                            illustration="https://cdn.shopify.com/s/assets/admin/checkout/settings-customizecart-705f57c725ac05be5a34ec20c05b94298cb8afd10aac7bd9c7ad02030f48cfa0.svg"
                            primaryAction={{
                                content: 'Learn more',
                                target: '_blank',
                                url: 'https://help.shopify.com/en/manual/online-store/themes/extend/apps#app-blocks"',
                            }}
                        >
                            {loading && (
                                <Spinner accessibilityLabel="Loading" size="large"/>
                            )}
                            <p>This app requires installation on the store front theme.</p>
                            <p>We have detected that your current theme is compatible with with Shopify app blocks</p>
                            <p>App blocks let you add app functionality exactly where you want to use it in your theme.
                                You
                                can add, remove, preview, reposition, and customize app blocks through the theme
                                editor.</p>
                            <p>
                                Please use the instructions below to enable the app on your store front.
                                <br/>
                                <br/>
                            </p>
                        </CalloutCard>
                    </Layout.Section>
                }
                {hasAppBlocks &&
                    <Layout.Section>
                        <LegacyCard title="How to add widget as an app block to store front">
                            <LegacyCard.Section>
                                <List type="number">
                                    <List.Item> From your Shopify admin, go to <strong>Online Store</strong>.
                                    </List.Item>
                                    <List.Item> On the current theme section, click <strong>Customize</strong>.
                                    </List.Item>
                                    <List.Item>Navigate to the product and section where you want to add the app
                                        block.
                                    </List.Item>
                                    <List.Item>Click <strong>Add block</strong></List.Item>
                                    <List.Item>From the drop-down menu, in the <strong>Apps</strong> section, select
                                        the 'Size Guide Widget' block to add to the section.
                                    </List.Item>
                                    <List.Item>Optional: move the app block to the place you want it in the section.
                                    </List.Item>
                                    <List.Item>Click <strong>Save</strong>.
                                    </List.Item>
                                </List>
                                <p className="NBIS-Install__CardContent">
                                    Alternatively to navigating to the product section manually, you can use the link
                                    below to open the theme editor on the product page automatically.
                                </p>
                                {appBlockLiveLink &&
                                    <div className="mt-20">
                                        <Button onClick={goToEditor} variant="primary">Preview in theme</Button>
                                    </div>
                                }
                            </LegacyCard.Section>
                        </LegacyCard>
                    </Layout.Section>
                }
                <Layout.Section>
                    <LegacyCard title="Manual liquid installation instructions">
                        <LegacyCard.Section>
                            <p>Follow these quick instructions to manually install Size Matters. You will need to paste
                                a snippet of code into your theme editor.</p><br/>
                            <p>Depending on how you want to display your size chart, you'll need to choose the
                                appropriate tab below (either 'inline', 'popup link' or 'popup button'), copy the
                                snippet and then do the following:</p>
                            <p>
                                <br/>
                            </p>
                            <List type="number">
                                <List.Item>
                                    {baseURL &&
                                        <>
                                            Open your theme editor by &nbsp;
                                            <Link url={'https://admin.shopify.com/store/' + baseURL + '/themes/current'}
                                                  external>
                                                clicking here
                                            </Link>
                                        </>
                                    }
                                    {!baseURL &&
                                        <>
                                            Open your theme editor
                                        </>
                                    }
                                </List.Item>
                                <List.Item>
                                    Search {`{{ product.description }}`} in either the 'product.liquid' or
                                    'product-template.liquid' tab
                                </List.Item>
                                <List.Item>
                                    Once you've located {`{{ product.description }}`} , place your cursor
                                    after {`</div>`} and press "enter" to insert a new line
                                </List.Item>
                                <List.Item>
                                    Once a new line has been inserted, paste the snippet of code from below
                                </List.Item>
                                <List.Item> Click "save" before continuing onto the next step of the process</List.Item>
                            </List>
                        </LegacyCard.Section>
                    </LegacyCard>
                </Layout.Section>
                <Layout.Section>
                    {displayInfo &&
                        <div className="mt-10 mb-10">
                            <Banner
                                title="Does your theme use sections?"
                                action={{
                                    content: 'Open sections/product-template.liquid', onAction() {
                                    }
                                }}
                                tone="info"
                                onDismiss={() => {
                                    setDisplayInfo(false)
                                }}
                            >
                                <p>If your templates/product.liquid template contains a line similar to the one below,
                                    it's possible
                                    that your theme is using sections:</p>
                                <p>
                                    <pre>{"{% section 'product-template' %}"}</pre>
                                </p>
                                <p>The code might need to go in sections/product-template.liquid instead.</p>
                            </Banner>
                        </div>
                    }
                </Layout.Section>
                <Layout.Section>
                    <LegacyCard title="Size Chart Code Snippets">
                        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
                            <LegacyCard.Section>
                                {selected == 0 &&
                                    <pre>
  {`<div data-app="eastsideco_sizeGuides"
       data-shop="{{ shop.permanent_domain }}"
       data-tags="{{ product.tags | join:',' | escape }}"
       data-metafields="{{ product.metafields.esc-size-matters.tag }}"
       data-popup="">
  </div>`}
                    </pre>
                                }
                                {selected == 1 &&
                                    <pre>
  {`<div data-app="eastsideco_sizeGuides"
     data-shop="{{ shop.permanent_domain }}"
     data-tags="{{ product.tags | join:',' | escape }}"
     data-metafields="{{ product.metafields.esc-size-matters.tag }}"
     data-popup="link">
</div>`}
                    </pre>
                                }
                                {selected == 2 &&
                                    <pre>
  {`<div data-app="eastsideco_sizeGuides"
     data-shop="{{ shop.permanent_domain }}"
     data-tags="{{ product.tags | join:',' | escape }}"
     data-metafields="{{ product.metafields.esc-size-matters.tag }}"
     data-popup="button">
</div>`}
                    </pre>
                                }

                            </LegacyCard.Section>
                        </Tabs>
                    </LegacyCard>
                </Layout.Section>
            </Layout>
            <div style={{ paddingBottom: '25px'}}></div>
        </Page>
);
}

export default Install;
